angular.module('impactx.address').controller('PhoneNumberController', PhoneNumberController);

PhoneNumberController.$inject = ["$scope"];

function PhoneNumberController($scope) {
    //var self = this;

    if($scope && $scope.data && !$scope.data.formatted && !$scope.dynamic) {
        $scope.data.formatted = this.format($scope.data);
    }

    /**
     * Creates or retrieves the placeholder text.
     *
     * @param translationKey key for translation.
     */
    this.getPlaceholder = function(translationKey) {
        if(translationKey && $scope.trns && $scope.trns[translationKey]) {
            return $scope.trns[translationKey];
        }
    };


    if($scope && !$scope.hasOwnProperty('showLabel')) {
        $scope.showLabel = true;
    }

    this.createId = function(data, postFix, customId) {
        postFix = postFix || '';

        if(customId && customId.length > 0) {
            return customId;
        }

        if(data) {
            if(data.label && data.label.length > 0) {
                return data.label + "-" + postFix;
            }
        }

        if($scope.name && $scope.name.length > 0) {
            return $scope.name + postFix;
        }

        return 'dummyField-' + postFix;
    };
}


(function(PhoneNumberController) {
    //
    //Extend prototype to provide a built-in method and save some memory.
    //
    /**
     * Default format method for phone numbers.
     * @param data data object to format
     * @param formatter custom formatter
     * @returns {string} formatted phone number
     */
    PhoneNumberController.prototype.format = function(data, formatter) {
        var codePart,
            networkCode,
            result = '',
            getValue = function(obj, defaultValue) {
                if(typeof obj === 'string') {
                    return obj;
                }

                if((typeof obj === 'object') && (obj.value)) {
                    if(typeof obj.value === 'number') {
                        return '' + obj.value;
                    }
                    return obj.value;
                }

                defaultValue = defaultValue || '';

                return defaultValue;
            };

        if(formatter && (typeof  formatter.format === 'function')) {
            //... avoid recursive calls to itself!
            if(formatter !== this) {
                return formatter.format(data);
            }
        }

        if(data) {
            //ToDo: Ensure that we have string data!

            codePart = getValue(data.countryCode, '');
            //+43 ?
            if(codePart.length > 0) {
                result = '+' + codePart;
            }

            codePart = getValue(data.areaCode, '');
            //631 ? or +xx-631 ?
            if(codePart.length > 0) {
                result += ((result.length > 0) ? '-' : '') + codePart + '/';
            }

            networkCode = getValue(data.networkCode, '');
            //+xx-xx/5553 ?
            if(networkCode.length > 0) {
                result += networkCode;
            }

            codePart = getValue(data.numberCode, '');
            //+xx-xx/xx-5553 or //+xx-xx/5553 ?
            if(codePart.length > 0) {
                result += ((networkCode.length > 0) ? '-' : '') + codePart;
            }

            return result;
        }

        return '';
    };

    PhoneNumberController.prototype.formatOrUndefined = function(data) {
        var result = this.format(data);

        if((typeof result === 'string') && result !== '') {
            return result;
        }
        //Otherwise undefined
    }
}(PhoneNumberController));